import { z } from 'zod';
import { sectionHasValue } from '../util';
import { registry } from '../registry';
export const integumentaryCardTitles = {
    root: 'Integumentary',
};
const integumentaryDetailOptions = [
    // Color
    { value: 'pallor', label: 'Pallor' },
    { value: 'flushed', label: 'Flushed' },
    { value: 'cyanotic', label: 'Cyanotic' },
    { value: 'mottling', label: 'Mottling' },
    { value: 'jaundice', label: 'Jaundice' },
    // Temp / Moisture
    { value: 'warm/dry', label: 'Warm/dry' },
    { value: 'cool', label: 'Cool' },
    { value: 'clammy', label: 'Clammy' },
    { value: 'diaphoresis', label: 'Diaphoresis' },
    { value: 'dry', label: 'Dry' },
    // Texture / Turgor
    { value: 'intact', label: 'Intact' },
    { value: 'thin/fragile', label: 'Thin/fragile' },
    { value: 'poor turgor', label: 'Poor turgor' },
    { value: 'edema', label: 'Edema' },
    // Lesions / Marks
    { value: 'erythema', label: 'Erythema' },
    { value: 'bruising', label: 'Bruising' },
    { value: 'ecchymosis', label: 'Ecchymosis' },
    { value: 'petechiae', label: 'Petechiae' },
    { value: 'rash', label: 'Rash' },
    { value: 'iad', label: 'IAD' },
    { value: 'pruritus', label: 'Pruritus' },
    { value: 'skin-tear', label: 'Skin tear' },
    { value: 'skin lesion requiring intervention', label: 'Skin lesion requiring intervention' },
    // Wounds / Access
    { value: 'incision', label: 'Incision' },
    { value: 'wounds', label: 'Wounds' },
    { value: 'iv access', label: 'IV access' },
];
const woundsPresentOptions = [
    { value: 'no-wounds', label: 'No wounds' },
    { value: 'pre-existing', label: 'Pre-existing' },
    { value: 'new-wound', label: 'New wound' },
    { value: 'stage-1-pi', label: 'Stage 1 PI' },
];
export const baseIntegumentarySchema = z
    .object({
    details: z
        .array(z.string())
        .optional()
        .register(registry, {
        label: 'Skin findings',
        options: [...integumentaryDetailOptions],
    }),
    narrative: z.string().optional().register(registry, { label: 'Skin Narrative:' }),
    woundsPresent: z
        .string()
        .optional()
        .register(registry, {
        label: 'Wounds Present?',
        options: [...woundsPresentOptions],
    }),
    wnl: z.boolean().optional().register(registry, { label: 'WNL' }),
})
    .register(registry, { label: integumentaryCardTitles.root });
export const baseIntegumentaryRefined = baseIntegumentarySchema.refine((data) => sectionHasValue(data), {
    message: 'Mark as within normal limits if none applies',
    path: [],
});
